import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { SaveNodeChangesAsync } from "../../SaveNodeChangesAsync";

export function MaxChildrenInput({
    state,
    setState,
}: {
    state: IRootNodeFormState;
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>;
}) {
    return (
        <FormInput
            id="nodeMaxChildren"
            type="number"
            onChange={(event) => {
                setState({
                    ...state,
                    newMaxChildren: Number.parseInt(event.target.value),
                });
            }}
            onEnter={async () => await SaveNodeChangesAsync()}
            maxWidth="50px"
            value={state.newMaxChildren ?? ``}
            classes={StyleClass(`maxChildrenInput`, {
                fontWeight: `bold`,
                fontSize: `20px`,
            })}
            showEnterHint={false}
            displayBlock={true}
        />
    );
}
